import { get } from "lodash";
import sentry from "../../../sentry";
import graphUrl from "../../../graph/utils/getUrl";
export default (function (err) {
    sentry.captureException(err);
    var e = err;
    e.errorCode = get(err, "response.data.errors.[0].errorCode", null);
    e.errorData = get(err, "response.data.data", {});
    throw e;
});
export function getGraphError(res) {
    if (!isGraphError(res)) {
        return res;
    }
    console.log(res);
    var err = new Error();
    err.message = get(res, "data.errors.[0].message", "errors.unknownError");
    err.apiError = get(res, "data.errors.[0].apiError", {});
    err.errorCode = get(res, "data.errors.[0].errorCode", null);
    err.errorData = get(res, "data.errors.[0].errorData", {});
    err.response = res;
    throw err;
}
function isGraphError(res) {
    var url = get(res, "config.url", "");
    var errors = get(res, "data.errors") || [];
    return url === graphUrl() && Array.isArray(errors) && errors.length > 0;
}
